{
  "serviceForms": {
    "error": {
      "caseNotFound": "Emme löytäneet tapaustasi. Tarkista, että sukunimi ja tapausnumero on syötetty oikein, ja yritä uudelleen. Jos ongelma jatkuu, otathan yhteyttä asiakaspalveluumme.",
      "lastNameMismatch": "Antamasi sukunimi ei vastaa tapausnumeroa. Tarkista, että sukunimi on oikein, ja yritä uudelleen."
    },
    "claimMissingAvios": {
      "departureDate": {
        "label": "Lähtöpäivä",
        "max": "Et voi hakea puuttuvia Avioksia etukäteen",
        "min": "Voit hakea puuttuvia Avioksia lennoista, joista on kulunut vähintään kaksi viikkoa ja korkeintaan kuusi kuukautta.",
        "pattern": "Lisää päivämäärä muodossa pp.kk.vvvv",
        "placeholder": "pp.kk.vvvv",
        "required": "Lähtöpäivä on pakollinen tieto",
        "selection": "Olet valinnut: Päivä: {day}. Kuukausi: {month}. Vuosi: {year}."
      },
      "error": {
        "aviosAlreadyGiven": "Aviokset on jo myönnetty lipulle",
        "genericError": "Jotain meni pieleen. Yritäthän myöhemmin uudelleen tai täytä alla olevat tiedot, jotta voimme käsitellä puuttuvia Avioksia koskevan hakemuksen.",
        "marketingCarrierIsInvalidForLoyalty": "Tämä lento ei oikeuta Avioksiin.",
        "memberNotFound": "Jäsentä ei löydy",
        "memberNotPartOfTicket": "Jäsentä ei löydy lipun tiedoista",
        "passengerDidNotFlyOnThisFlightDate": "Tästä lennosta ei voi ansaita Avioksia, sillä lentoa ei ole lennetty.",
        "passengerIsAnIdPassenger": "Tämä lento ei oikeuta Avioksiin.",
        "passengerIsNoShowForThisFlightDate": "Tästä lennosta ei voi ansaita Avioksia, sillä lentoa ei ole lennetty.",
        "passengerNameNotFound": "Jotain meni pieleen: nimi ei täsmää. Yritäthän myöhemmin uudelleen tai täytä alla olevat tiedot, jotta voimme käsitellä puuttuvia Avioksia koskevan hakemuksen.",
        "requestNotEligibleAnymore": "Avioksia ei voi enää lisätä. Voit lisätä puuttuvat Aviokset 6 kuukauden kuluessa viimeisimmän lennon jälkeen.",
        "requestNotYetEligibleProcessingDelayNotReached": "Avioksia ei voi vielä lisätä. Odotathan 10 päivää viimeisen lennon jälkeen hakeaksesi puuttuvia Avioksia.",
        "thisFlightIsACharterFlight": "Tämä lento ei oikeuta Avioksiin.",
        "thisFlightIsAnAdhocFlight": "Tämä lento ei oikeuta Avioksiin.",
        "thisFlightWasAlreadyAccrued": "Aviokset on jo myönnetty.",
        "thisFlightWasAlreadyAccruedForAnotherFrequentFlyerCard": "Aviokset on jo myönnetty toiselle jäsentilille.",
        "thisPassengerUsedARedemptionTicket": "Tämä lento ei oikeuta Avioksiin.",
        "ticketNotFound": "Lippua ei löydy annetulla lipun numerolla"
      },
      "flightDate": {
        "label": "Lennon päivämäärä",
        "max": "Et voi hakea puuttuvia Avioksia etukäteen",
        "min": "Voit hakea puuttuvia Avioksia lennoista, joista on kulunut vähintään kaksi viikkoa ja korkeintaan kuusi kuukautta.",
        "pattern": "Lisää päivämäärä muodossa pp.kk.vvvv",
        "placeholder": "pp.kk.vvvv",
        "required": "Lennon päivämäärä on pakollinen tieto. Lisää päivämäärä muodossa pp.kk.vvvv",
        "selection": "Olet valinnut: Päivä: {day}. Kuukausi: {month}. Vuosi: {year}."
      },
      "flightNumber": {
        "label": "Lennon numero",
        "pattern": "Kirjoita lentosi numero ilman lentoyhtiön koodia.",
        "placeholder": "Esim. 41",
        "required": "Lennon numero on pakollinen tieto."
      },
      "helpLink": "Lisätietoa",
      "helpModal": {
        "localSettings": {},
        "url": "/fi-fi/lis%C3%A4tietoa-3309066"
      },
      "helpTitle": "Lisätietoa",
      "loggedInFlightsIntro": "<p><b>Voit lisätä puuttuvia Avioksia takautuvasti 2 viikon–6 kuukauden kuluessa</b> matkustuspäivästä Finnairin tai yhteistyökumppaniemme reittilennoista.</p>",
      "loginPromotion": {
        "description": "Finnair Plus -jäsenenä voit lisätä Avioksia lennostasi täyttämällä lomakkeen sisäänkirjautumisen jälkeen.",
        "footerText": "Sisäänkirjautumisen jälkeen sinut ohjataan takaisin tälle sivulle.",
        "loginHeading": "Kirjaudu sisään tilillesi ja lisää puuttuvia Avioksia"
      },
      "notLoggedInFlightsIntro": "<p><b>Voit hakea puuttuvia Avioksia takautuvasti 2 viikkoa–6 kuukautta</b> matkustuspäivän jälkeen Finnairin tai yhteistyökumppaniemme reittilennoista tai Finnair Plus -yhteistyökumppaneiden palveluista, kuten hotelleista, autonvuokrauksista ja muista palveluista.</p>",
      "partnerIntro": "<p><b>Jos haluat lisätä puuttuvia Avioksia lennoista, klikkaa Lennoista-välilehteä.</b></p><p>Tällä lomakkeella voit hakea puuttuvia Avioksia <b>Finnair Plus -yhteistyökumppaneiden palveluista, kuten hotelleista, autonvuokrauksista ja muista palveluista.</b>.</p><p>Mukaan tulee liittää myös kopio vuokraussopimuksesta tai hotellin laskusta.</p><p> Avioksien ansaitsemisen säännöt saattavat olla erilaiset joidenkin Finnair Plus -yhteistyökumppaneiden palveluissa. Lue lisää mahdollisista rajoituksista <a href=\\\"https://www.finnairshop.com/fi/finnair-plus-awards-and-products\\\" target=\\\"_blank\\\">Finnair Shopista.</a></p>",
      "returnDate": {
        "label": "Paluupäivä",
        "max": "Et voi hakea puuttuvia Avioksia etukäteen",
        "min": "Voit hakea puuttuvia Avioksia lennoista, joista on kulunut vähintään kaksi viikkoa ja korkeintaan kuusi kuukautta.",
        "pattern": "Lisää päivämäärä muodossa pp.kk.vvvv",
        "placeholder": "pp.kk.vvvv",
        "required": "Paluupäivä on pakollinen tieto",
        "selection": "Olet valinnut: Päivä: {day}. Kuukausi: {month}. Vuosi: {year}."
      },
      "ticketNumber": {
        "label": "Lipun numero",
        "pattern": "Lipun numerossa tulee olla 13 numeroa",
        "required": "Lipun numero on pakollinen tieto"
      },
      "ticketNumberHelpModal": {
        "localSettings": {},
        "url": "/fi-fi/lippunumero-s%C3%A4hk%C3%B6isess%C3%A4-lippukuitissa-2778600"
      },
      "ticketNumberHelpTitle": "Lipun numero"
    }
  }
}
